import { PermissionAction, PermissionResource } from '@entities/client/permission';

import { requirePermission } from '../../../require-permission';

export const createCardLoader = requirePermission(
  PermissionResource.ClientCards,
  PermissionAction.Write,
);
